
import moment from "moment"
moment.locale("zh-cn")
export function getSearchParm(obj){
    return new Proxy(obj,{
        get(target,key){
            if(target[key] == ""||target==null){
                return undefined
            }
	    if(moment.isMoment(target[key])){
		    if(key == "tt1"||key=="tt2"){
			return target[key].format("YYYY-MM-DD"); 
		    }
			return target[key].format("YYYY-MM")
	    }
            return target[key]
        },
    })
}